import React, { Component } from 'react';
import { connect } from 'react-redux';
import HeatMapBlock from './Charts/HeatMapBlock';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import moment from 'moment';
import PageTemplate from "./PageTemplate";
import { MdOutlineFileDownload } from "react-icons/md";
import { MdOutlineClose } from "react-icons/md";
import html2canvas from 'html2canvas';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
    this.state = {
      showMainPage: true,
      showFilter: false,
      showValue: '',
      showTabView: 2,
      showModalDownload: false
    }
  }

  componentDidMount() {

  }



  exportPDFWithComponent = () => {
    if (this.pdfExportComponent.current === null) {
      return;
    }

    try {
      return (this.pdfExportComponent.current ?
        html2canvas(this.pdfExportComponent.current, {
          scale: 3,
          width: 900,
          height: 750
        })
          .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');

            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'AssessmentThemes.png';
            link.click();

            console.log("imgData", imgData)

            return imgData
          }).catch((err) => {
            console.log("err", err)
            return null
          }) : null)
    }
    catch (error) {
      console.log("error", error)

      return null
    }
  };




  // exportPDFWithComponent = () => {
  //   if (this.pdfExportComponent.current) {
  //     this.pdfExportComponent.current.save();
  //   }
  // };

  closeFilter = (check1, check2) => {
    this.setState({ showFilter: check1, showValue: check2 });
  }

  openSurveyResponse = () => {
    this.setState({ showOverview: false });

  }

  closeResponseAnalytics = () => {
    this.setState({ showOverview: true })
  }

  onOptionType = (value) => {
    this.setState({ optionType: value })
  }

  handleStrength = (params) => {
    let { handleThemeStrenght } = this.props;
    let { FilterValues } = this.state;
    let name = ''
    if (params && params.name) {
      name = params.name;
    }
    handleThemeStrenght(name, FilterValues);
    this.setState({ showMainPage: false })
  }

  handleMultifilterIndexScore2 = (finalFilter, name) => {

    let { handlAssessmentDashboard } = this.props;
    this.setState({
      FilterValues: finalFilter,
      ListName: name,
      showMainPage: true
    });

    handlAssessmentDashboard(finalFilter, true);

  }

  handleGOTOTheme = () => {
    this.setState({ showMainPage: true })
  }

  handleTabView = (value) => {
    this.setState({ showTabView: value })
  }

  handleDownloadClick = () => {
    this.setState({ showModalDownload: true });
  };

  handleCloseDownloadModal = () => {
    this.setState({ showModalDownload: false });
  };

  render() {

    let { loading, hexToRgbA, crrSelectedEmp, EditDetailsFn, getTopBottomIndex, getAssessmentReportByEmpIDData, getAssessmentDimensionsData, EditButtonFn, handlePlayVideo, isSchool } = this.props;
    let { showTabView } = this.state;

    // console.log("getAssessmentDimensionsData----->", getAssessmentDimensionsData)

    let AssessmentList = []
    if (getAssessmentDimensionsData && getAssessmentDimensionsData.length > 0) {
      getAssessmentDimensionsData.forEach((element) => {
        AssessmentList.push({
          ...element,
          finalSum: (Number(element.count) * Number(element.rankSum))
        })
      })
      AssessmentList.sort((a, b) => (a.finalSum - b.finalSumSum))
    }

    // console.log("AssessmentList--1->", AssessmentList)
    let newList = []
    if (AssessmentList && AssessmentList.length > 0) {
      AssessmentList.forEach((element, index) => {

        let rank = (AssessmentList.length - index);

        let check = 0;
        if (showTabView === 1) {
          check = 1
        } else if (showTabView === 2 && (rank <= 5)) {
          check = 2
        } else if (showTabView === 3 && (rank <= 7)) {
          check = 3
        } else if (showTabView === 4 && (rank <= 10)) {
          check = 4
        }
        console.log("check--1->", check)

        let getIndex = newList.findIndex(prev => prev.bucket === element.bucket)
        if (getIndex === -1) {
          let temp = {
            "showCount": 0,
            "bucket": element.bucket,
            "colorCode": element.colorCode,
            "dimensions": [{
              "rank": rank,
              "check": check,
              "name": element.dimension,
              "count": element.count,
              "finalSum": element.finalSum,
              "colorCode": element.colorCode,
            }],
          }
          newList.push(temp)
        } else {
          newList[getIndex]["showCount"] += 1

          newList[getIndex]["dimensions"].push({
            "rank": rank,
            "check": check,
            "name": element.dimension,
            "count": element.count,
            "finalSum": element.finalSum,
            "colorCode": element.colorCode,
          })
        }



      });
    }

    let newV2List = [];
    if (newList && newList.length > 0) {
      for (var ix = 0; ix < newList.length; ix++) {
        let details = newList[ix];
        let temp = details;
        if (details && details.dimensions && details.dimensions.length > 0) {
          temp["dimensions"] = details.dimensions.sort((a, b) => (a.rank - b.rank));
        }
        newV2List.push(temp)
      }
    }


    function getLightColor(bucket) {
      let obj = {
        "THINKING TALENTS": "#FFF0C4",
        "ACTING TALENTS": "#CAE6FC",
        "LEADING TALENTS": "#DBD0EE",
        "RELATING TALENTS": "#D4ECD5"
      }
      return obj && obj[bucket] ? obj[bucket] : "#F2F2F2"
    }


    let xsList = getAssessmentDimensionsData;
    function getElements(value, type, list) {
      if (list && list.length > 0) {
        if (type === "dimension") {
          const index = list.findIndex(
            item => item.dimension === value
          );
          return index !== -1 ? list[index] : {};
        } if (type === "bucket") {
          const index = list.findIndex(
            item => item.bucket === value
          );
          return index !== -1 ? list[index] : {};
        } else {
          return {}
        }
      } else {
        return {}
      }
    }



    return (
      <>

        <div className="w-full mt-4">

          <div className="grid grid-cols-1 gap-4 md:grid-cols-1">

            <div className="md:p-6 p-4 bg-white border shadow-sm rounded-xl">

              <div className='flex items-center justify-between pt-2 pb-6'>
                <h1 className="text-xl font-semibold text-gray-800 md:text-2xl">
                  {
                    isSchool ? EditButtonFn('Top5TalentPlustheme', "Dominant Teen TalentPlusStrengths  theme") :
                      EditButtonFn('DominantThemes', "Dominant TalentPlusStrengths  theme")
                  }
                </h1>
                <div className="flex items-center justify-end">
                  <div className="flex items-center space-x-4 cursor-pointer px-4 py-2 border border-[#212121] rounded-md hover:bg-[#F2F2F2]" onClick={this.handleDownloadClick}>
                    {EditButtonFn('DominantThemes', "Dominant Themes")}
                    <MdOutlineFileDownload size={24} />
                  </div>
                </div>
              </div>

              <div className={isSchool ? 'grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3' : 'grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4'}>
                {newV2List && newV2List.length > 0 ?
                  newV2List.map((item) =>
                    <>
                      <div className={''}>
                        <h1 className='text-lg text-center text-[#3D405B] font-semibold bg-[#F2F2F2] px-4 py-3 mb-2'>{
                          EditDetailsFn(getElements((item.bucket.toString()).trim(), "bucket", xsList), "bucket", (item.bucket.toString()).trim())
                        }</h1>
                        <HeatMapBlock
                          item={item}
                          isSchool={isSchool}
                          handlePlayVideo={handlePlayVideo}
                          EditButtonFn={EditButtonFn}
                          EditDetailsFn={EditDetailsFn}
                          xsList={xsList}
                          getElements={getElements}
                        />
                      </div>
                    </>
                  ) : null}
              </div>

              {!(newV2List && newV2List.length > 0) ?
                <>
                  {!loading ?
                    <div className="pt-16 pb-24 text-center text-xl text-[#3d405B]/70">Data Not Available</div>
                    : null}
                </>
                : null}


              {this.state.showModalDownload && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
                  <div className="bg-white rounded-lg shadow-lg p-1">
                    <div className="max-w-4xl w-full">
                      <div className="">
                        <div className='p-4 flex items-center justify-between border-b'>
                          <h2 className='textcolor font-semibold text-xl'>Dominant Themes Snippet Preview</h2>
                          <div className="flex items-center space-x-3">
                            <div
                              onClick={() =>
                                this.exportPDFWithComponent()
                              }
                              className="flex items-center space-x-4 cursor-pointer px-4 py-2 border border-[#212121] textcolor rounded-md hover:bg-[#F2F2F2]" >
                              <div>Download</div>
                              <MdOutlineFileDownload size={24} />
                            </div>
                            <div className="bg-[#F2F2F2] p-2 rounded-md textcolor cursor-pointer hover:bg-[#EEEEEE]" onClick={this.handleCloseDownloadModal}>
                              <MdOutlineClose size={24} />
                            </div>
                          </div>
                        </div>

                        <div ref={this.pdfExportComponent}>
                          <div style={{ width: '900px', height: '780px' }} className='bg-white max-h-[80vh] p-4 overflow-y-auto'>
                            <div className='space-y-5 border p-4'>
                              <h1 className="text-center text-2xl font-medium text-[#212121] italic">
                                <b>{
                                  crrSelectedEmp && crrSelectedEmp["name"] ?
                                    crrSelectedEmp["name"] : ""
                                }</b>
                              </h1>
                              <div className="space-y-3">
                                <div className="text-start p-4 bg-[#F2F2F2] textcolor">
                                  <p className="text-xl font-semibold pb-3">Your dominant TalentPlusStrengths themes</p>
                                  <p>Your <b>Dominant Themes</b> are the core qualities that define who you are and contribute to your success. Understanding, nurturing, and regularly using these strengths are key to experiencing a thriving life.</p>
                                </div>

                                {getAssessmentReportByEmpIDData && getAssessmentReportByEmpIDData.length > 0 ?
                                  getAssessmentReportByEmpIDData.map((element, index1) =>
                                    (index1 + 1 <= getTopBottomIndex(getAssessmentReportByEmpIDData, "top").range1) ?
                                      <div className="pl-6 w-full">
                                        <div className="relative flex items-center justify-center h-[4.4rem] text-black text-lg pl-16 pr-12 w-full" style={{ background: getLightColor(element.bucket) }}>
                                          <div className="absolute left-0 top-1/2 -translate-y-1/2 -ml-6">
                                            <div style={{ background: getLightColor(element.bucket) }} className="w-[4.5rem] h-[4.5rem] pb-3 bg-[#FFC400] rounded-full flex items-center justify-center text-black font-bold text-base border-4 border-white">{index1 + 1}</div>
                                          </div>
                                          <div className="flex items-center w-full pb-3">
                                            <p className="font-semibold w-44 text-start">
                                              {EditDetailsFn(element, 'dimension', element.dimension)}
                                            </p>
                                            <p className="text-base text-start w-full">
                                              {EditDetailsFn(element, 'desc', element.details.desc)}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      : null
                                  ) : null}

                              </div>
                              <div className='flex items-center justify-between' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className='pt-4 mr-20'>
                                  <img src="/img/logo/TalentPlusStrengths_logo.svg" className="object-cover w-24 mx-4" alt="default_survey_logo" />
                                </div>
                                <div className='pt-2'>
                                  <p className='text-sm text-[#212121]/70'>Copyright © 2025, HappyPlus, Inc. All rights reserved</p>
                                </div>
                                <div className='ml-14'>
                                  <img src="/img/logo/happyplus-logo-with-powered-by.svg" className="object-cover w-22 mx-4" alt="default_survey_logo" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* </PDFExport> */}


                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapStateToProps(state) {
  // ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { users, dashboard } = state;
  return {
    loggingIn,
    users,
    dashboard
  };
}
export default connect(mapStateToProps)(Overview);
